import { createConfirmation } from "react-confirm";

import { ConfirmOptionDialog } from "../../components/shared/dialogs/index.js";

export default (title, options = {}) => createConfirmation(ConfirmOptionDialog)({ title, ...options });
